import { Rinvio } from '../../../models/rinvio';
import { Motivo } from '../../../models/tipologiche/motivo';

export class RinvioAdapter {
  id: string;
  dataDa: number;
  dataA: number;
  ora: string;
  motivo: Motivo;
  note: string;

  constructor(rinvio: Rinvio) {
    this.id = rinvio.id;
    this.dataDa = rinvio.dataDa;
    this.dataA = rinvio.dataA;
    this.ora = rinvio.ora;
    this.motivo = rinvio.motivo ? JSON.parse(JSON.stringify(rinvio.motivo)) : null;
    this.note = rinvio.note;
  };
}
